import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toHandlers as _toHandlers, mergeProps as _mergeProps, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/overview/spiral-icon.svg'


const _hoisted_1 = { class: "text-base" }
const _hoisted_2 = { class: "flex justify-between text-base mt-8 gap-3" }
const _hoisted_3 = { class: "flex flex-col w-1/3" }
const _hoisted_4 = { class: "bg-white rounded-xl p-6 border border-gray-200 shadow-card relative" }
const _hoisted_5 = { class: "absolute top-5 right-5" }
const _hoisted_6 = { class: "absolute z-10 top-0 right-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_7 = { class: "text-base font-semibold flex justify-between" }
const _hoisted_8 = { class: "text-sm" }
const _hoisted_9 = { class: "flex justify-between items-center mt-6" }
const _hoisted_10 = { class: "text-2xl font-semibold" }
const _hoisted_11 = { class: "flex gap-1 mt-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "spiral"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", { class: "text-sm font-medium text-green-800" }, "90%", -1)
const _hoisted_14 = { class: "font-medium text-sm text-gray-600" }
const _hoisted_15 = { class: "bg-gray-200 rounded-full h-[8px] mt-6" }
const _hoisted_16 = { class: "flex flex-col w-1/3" }
const _hoisted_17 = { class: "bg-white rounded-xl p-6 border border-gray-200 shadow-cards relative" }
const _hoisted_18 = { class: "absolute top-5 right-5" }
const _hoisted_19 = { class: "absolute z-10 top-0 right-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_20 = { class: "text-base font-semibold flex justify-between" }
const _hoisted_21 = { class: "text-sm" }
const _hoisted_22 = { class: "flex justify-between items-center mt-6" }
const _hoisted_23 = { class: "text-2xl font-semibold" }
const _hoisted_24 = { class: "flex gap-1 mt-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "spiral"
}, null, -1)
const _hoisted_26 = { class: "text-sm font-medium text-green-800" }
const _hoisted_27 = { class: "font-medium text-sm text-gray-600" }
const _hoisted_28 = { class: "bg-gray-200 rounded-full h-[8px] mt-6" }
const _hoisted_29 = { class: "flex flex-col w-1/3" }
const _hoisted_30 = { class: "bg-white rounded-xl p-6 border border-gray-200 shadow-cards relative" }
const _hoisted_31 = { class: "absolute top-5 right-5" }
const _hoisted_32 = { class: "absolute z-10 top-0 right-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_33 = { class: "text-base font-semibold flex justify-between" }
const _hoisted_34 = { class: "text-sm" }
const _hoisted_35 = { class: "flex justify-between items-center mt-6" }
const _hoisted_36 = { class: "text-2xl font-semibold" }
const _hoisted_37 = { class: "flex gap-1 mt-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "spiral"
}, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h4", { class: "text-sm font-medium text-green-800" }, "80%", -1)
const _hoisted_40 = { class: "font-medium text-sm text-gray-600" }
const _hoisted_41 = { class: "bg-gray-200 rounded-full h-[8px] mt-6" }
const _hoisted_42 = { class: "pt-6" }
const _hoisted_43 = { class: "grid grid-cols-4 gap-6" }
const _hoisted_44 = { class: "col-span-3 space-y-6" }
const _hoisted_45 = { class: "bg-white p-4 pb-1 rounded-lg shadow-cards border border-gray-200 relative" }
const _hoisted_46 = { class: "absolute top-6 right-4" }
const _hoisted_47 = { class: "absolute z-10 top-0 right-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_48 = { class: "flex justify-between" }
const _hoisted_49 = { class: "text-base font-semibold mb-4" }
const _hoisted_50 = { class: "flex items-center justify-end gap-2 mr-10 max-w-[40%]" }
const _hoisted_51 = ["value"]
const _hoisted_52 = ["value"]
const _hoisted_53 = { class: "" }
const _hoisted_54 = { class: "col gap-6" }
const _hoisted_55 = { class: "bg-white p-4 rounded-lg shadow-cards border border-gray-200 h-[22rem]" }
const _hoisted_56 = { class: "relative h-full w-full" }
const _hoisted_57 = { class: "absolute top-1 right-0" }
const _hoisted_58 = { class: "absolute z-10 top-0 right-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_59 = { class: "text-lg font-semibold mb-4 flex justify-between" }
const _hoisted_60 = { class: "relative" }
const _hoisted_61 = { class: "flex flex-col bg-white gap-3" }
const _hoisted_62 = { class: "flex flex-col items-center px-4 py-6" }
const _hoisted_63 = { class: "mt-6 font-semibold text-2xl text-gray-900" }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = { class: "font-normal text-sm text-red-600 text-center mt-5" }
const _hoisted_66 = { class: "mt-4 px-10 w-full text-sm text-gray-600" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "First Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Last Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Grade"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-left" }, "Class")
  ])
], -1)
const _hoisted_68 = ["onClick"]

import BarGraphComponent from "../components/BarGraphComponent.vue";
import PieChartComponent from "../components/PieChartComponent.vue";
import { computed, inject, onBeforeMount, onMounted, ref } from "vue";
import { useActivityStore } from "@/stores/activityStore";
import { useFilterStore } from "@/stores/filterStore";
import { useLearnerStore } from "@/stores/learnerStore";
import { useSubjectStore } from "@/stores/subjectStore";
import moment from "moment";
import i18n from "@/plugins/i18n";
import tooltip from "@/components/global/TooltipComponent.vue";
import { useSchoolStore } from "@/stores/schoolStore";
import UnassignedStudentsTable from "../components/UnassignedStudentsTable.vue";
import { useDataStore } from "@/stores/dataStore";
import LearnerListModalComponent from "../components/LearnerListModalComponent.vue";
import { Learner } from "@/interfaces/learner.interface";
import { useUserStore } from "@/stores/userStore";
import { SchoolStructureClassGroup } from "@/interfaces/school-structure.interface";

import LoadingSpinnerComponent from "../components/LoadingSpinnerComponent.vue";
import PageHeaderComponent from "@/components/global/PageHeaderComponent.vue";
import router from "@/router";
import { DatePicker } from "v-calendar";
import "v-calendar/style.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'OverviewPage',
  setup(__props) {

const bus = inject("bus") as any;

const showStudentModal = (userId: string) => {
  bus.emit("show-student-modal", { userId: userId });
};

// Stores
const activityStore = useActivityStore();
const filterStore = useFilterStore();
const learnerStore = useLearnerStore();
const schoolStore = useSchoolStore();
const subjectStore = useSubjectStore();
const userStore = useUserStore();
const dataStore = useDataStore();

// Reactive variables
const adminClassGroupIds = ref<string[]>([]);
const dates = ref<string[]>([]);
const x_axis_months = ref<string[]>([]);
const showLearnersListModal = ref(false);
const learnerListModalTitle = ref("");
const learnersList = ref<Learner[]>([]);
// student upload
const loading = ref(false);
const showLearnersBulkUploadProgressModal = ref(false);
const studentCounts = ref<{ [key: string]: number }>({});

const studentsWithoutClasses = computed(() => {
  return learnerStore.getSchoolLearners?.filter(
    (student) => {
      return !student.classes || student.classes.length === 0;
    }) || [];
});

onBeforeMount(async () => {
  // Fetch initial data to ensure loading state is set and data is populated
  // Initialize filters if no school is selected
  const shouldInit = !filterStore.selectedFilters.school;
  await dataStore.fetchInitialData(shouldInit);

  // Get the dates for the last 12 weeks
  generateLast12Weeks();
});

// get teacher classes
const teacherClasses = computed(() => {
  const currentClasses = schoolStore.getSchoolStructure?.classGroups;

  return currentClasses?.filter((item) => {
    if (userStore.getAdminClassGroupIds.includes(item._id)) {
      return true
    }
  });
});

const selectStudentsTable = ref(false);
const selectedClass = ref<SchoolStructureClassGroup | null>(null);
const selectedClassData = ref<SchoolStructureClassGroup | null>(null);

const showLearnerTable = (classes: any) => {
  selectStudentsTable.value = true;
  selectedClass.value = classes;

  // Filter the currentClasses to find only the data related to the selected class
  selectedClassData.value = schoolStore.getSchoolStructure?.classGroups.find(
    (group) => group.name === classes.name && group.subject === classes.subject
  ) || null;

};

// Get total number of learners in a class
const totalLearners = computed(() => {
  // Active class IDs array
  const activeClasses = filterStore.selectedFilters.classGroup;

  // Get the selected grade level
  const selectedGradeLevel = filterStore.selectedFilters.gradeLevel;

  // Get all learners
  const allLearners = learnerStore.getSchoolLearners;

  if (activeClasses && activeClasses.length > 0) {
    // Filter learners by selected class groups
    const learnersInClasses = allLearners.filter(
      (student) =>
        student?.classes &&
        student.classes.some((studentClass) =>
          activeClasses.includes(studentClass._id)
        )
    );
    return learnersInClasses.length;
  } else if (selectedGradeLevel !== undefined && selectedGradeLevel !== -1) {
    // No class groups selected, filter learners by grade level
    const learnersInGrade = allLearners.filter(
      (student) => student.grade === selectedGradeLevel
    );
    return learnersInGrade.length;
  } else {
    // If no grade level is selected, return all total learners
    return allLearners.length;
  }
});

// Generate progress bar background for activity cards
const activeWithin7DaysColours = (percentage: number) => {
  // Red Color
  if (percentage <= 50) {
    return "bg-red-300";
  }

  // Yellow Color
  if (percentage > 50 && percentage < 80) {
    return "bg-yellow-400";
  }

  // Green Color
  if (percentage >= 80) {
    return "bg-emerald-200";
  }
};

const activeTimeColours = (percentage: number) => {
  // Red Color
  if (percentage <= 25) {
    return "bg-red-300";
  }

  // Yellow Color
  if (percentage > 25 && percentage <= 35) {
    return "bg-yellow-400";
  }

  // Green Color
  if (percentage > 35) {
    return "bg-emerald-200";
  }
};

const averageTimeSpentLearningColours = (percentage: number) => {
  // Red Color
  if (percentage <= 50) {
    return "bg-red-300";
  }

  // Yellow Color
  if (percentage > 50 && percentage < 80) {
    return "bg-yellow-400";
  }

  // Green Color
  if (percentage >= 80) {
    return "bg-emerald-200";
  }
};

// Generate progress bar background
const generateProgressBarBg = (percentage: number) => {
  // Red Color
  if (percentage <= 50) {
    return "#FDA29B";
  }

  // Yellow Color
  if (percentage > 50 && percentage < 80) {
    return "#FEC84B";
  }

  // Green Color
  if (percentage >= 80) {
    return "#ABEFC6";
  }
};

// Loop through the dates array and check the store data for the corresponding date
// and returning the students count.
const barGraphData = computed(() => {
  return dates.value?.map((date) => {
    // Find the task data for the corresponding date (full date comparison)
    const taskData =
      activityStore.getDailyTasksData?.tasksCompletionGraph?.find(
        (task: any) => task.week === date // Compare the full date string now
      );

    moment.updateLocale("en", {
      week: {
        dow: 1, // First day of week is Monday
        doy: 4  // First week of year must contain 4 January (7 + 1 - 4)
      }
    });

    const formattedDate = moment(date, "YYYY-ww").startOf("week").format("DD MMM");

    // Return the day and the number of students for the graph
    return {
      week: formattedDate,
      students: taskData?.count || 0,
      studentsWhoCompletedTasks: taskData?.usersWhoCompletedTasks || [],
      color: generateProgressBarBg(
        Math.min(
          Math.round(((taskData?.count || 0) / totalLearners.value) * 100),
          100
        )
      ),
      totalLearners: totalLearners.value,
    };
  });
});

// Pie chart data
const pieChartData = computed(() => {
  // Get the performance data from the store
  const performance =
    activityStore.getDailyTasksData?.tasksCompletionPerformance;

  // console.log("performance", performance);

  // Return the data in the format required by the PieChartComponent
  return [
    {
      value: Math.round(performance?.studentsOnTrack ?? 0),
      name: i18n.global.t("overview_page.on_track"),
    },
    {
      value: Math.round(performance?.studentsBehind ?? 0),
      name: i18n.global.t("overview_page.falling_behind"),
    },
    {
      value: Math.round(performance?.studentsAhead ?? 0),
      name: i18n.global.t("overview_page.ahead"),
    },
  ];
});

const learnerTaskCompletionStatus = (data: any) => {
  const dataIndex = data.dataIndex;
  const performanceData = activityStore.getDailyTasksData?.tasksCompletionPerformance;

  switch (dataIndex) {
    case 0:
      // Set the learnersList to the studentsOnTrackList
      learnerListModalTitle.value = i18n.global.t("overview_page.students") + ' ' + i18n.global.t("overview_page.on_track");
      learnersList.value = learnerStore.getSchoolLearners.filter((learner) =>
        performanceData.studentsOnTrackList.includes(learner._id)
      );
      break;
    case 1:
      // Set the learnersList to the studentsBehindList
      learnerListModalTitle.value = i18n.global.t("overview_page.students") + ' ' + i18n.global.t("overview_page.falling_behind");
      learnersList.value = learnerStore.getSchoolLearners.filter((learner) =>
        performanceData.studentsBehindList.includes(learner._id)
      );
      break;
    case 2:
      // Set the learnersList to the studentsAheadList
      learnerListModalTitle.value = i18n.global.t("overview_page.students") + ' ' + i18n.global.t("overview_page.ahead");
      learnersList.value = learnerStore.getSchoolLearners.filter((learner) =>
        performanceData.studentsAheadList.includes(learner._id)
      );
      break;
  }

  showLearnersListModal.value = true;
}

const taskCompletionLearners = (data: any) => {
  const dataName = data.name;
  const graphData = barGraphData.value;

  // Find the corresponding data for the selected date
  const selectedData = graphData.find((item) => item.week === dataName);

  // Get learners by their IDs
  const learners = selectedData?.studentsWhoCompletedTasks || [];
  const filteredLearners = learnerStore.getSchoolLearners.filter((learner) =>
    learners.includes(learner._id)
  );

  learnerListModalTitle.value = dataName;
  learnersList.value = filteredLearners;

  showLearnersListModal.value = true;
}

// Active and time data froma activity store
const activeTime = computed(() => {
  //getting data from the store
  const active = activityStore.getActivityData;

  //returning the data
  return {
    percentageActiveInLast7Days: `${Math.round(
      active?.percentageActiveInLast7Days ?? 0
    )}%`,
    averageAppTimePerLearner: Math.floor(
      Math.round((active?.averageAppTimePerLearner ?? 0) / 60)
    ),
    percentageTimeSpentLearning: `${Math.round(
      active?.percentageTimeSpentLearning ?? 0
    )}%`,
    //Progress bar calculations
    progressbar: {
      percentageActiveInLast7Days:
        (Math.round(active?.percentageActiveInLast7Days ?? 0) / 90) * 100,
      averageAppTimePerLearner:
        (Math.round((active?.averageAppTimePerLearner ?? 0) / 60) / 35) * 100,
      percentageTimeSpentLearning:
        (Math.round(active?.percentageTimeSpentLearning ?? 0) / 100) * 100,
    },
  };
});

// Generate the last 12 weeks
const generateLast12Weeks = () => {
  // Clear any existing dates
  dates.value = [];

  // Generate the last 12 weeks
  for (let week = 0; week < 12; week++) {
    const date = moment().subtract(week, "weeks");
    const formattedDate = date.format("YYYY-ww");
    dates.value.push(formattedDate);
  }

  // Reverse to get chronological order
  dates.value.reverse();
};

const processReceivedLearners = (learners: any) => {
  // console.log("LEARNERS TO UPLOAD: ", learners);
  submitLearnersForUpload(learners);
};

const submitLearnersForUpload = async (learners: any) => {
  loading.value = true;
  try {
    // Submitting the uploaded learners for bulk creation in the learner store
    let request = await learnerStore.addLearnerToClass(learners, selectedClass.value?._id || '');
    showLearnersBulkUploadProgressModal.value = true;
    console.log("Request: ", request);
    loading.value = false;
  } catch (error) {
    console.error(error);
    loading.value = false;
  }
};

const uploadInProgress = () => {
  // Resetting the UI states after upload is in progress
  showLearnersBulkUploadProgressModal.value = false;
};

const updateStudentCount = ({ count, classId }: { count: number; classId: string }) => {
  studentCounts.value = { ...studentCounts.value, [classId]: count };
  // console.log("studentCounts", studentCounts.value);
};

const submitNewLearners = async (learners: any) => {
  loading.value = true;
  try {
    // Submitting the uploaded learners for bulk creation in the learner store
    if (selectedClass.value) {
      await learnerStore.addLearnerToClass(learners.learners, selectedClass.value?._id || '');
    }
    loading.value = false;
  } catch (error) {
    console.error(error);
    loading.value = false;
  }

  // data store call
  await dataStore.fetchSchoolStructureData();
};

onMounted(async () => {

  const classGroups = schoolStore.getSchoolStructure?.classGroups || [];
  const counts = await Promise.all(
    classGroups.map(async (classGroup) => {
      const learners = await learnerStore.getLearnersByClassId(classGroup._id);
      return { classId: classGroup._id, count: learners.length };
    })
  );
  counts.forEach(({ classId, count }) => {
    studentCounts.value[classId] = count;
  });
});

const hideLearnerTable = () => {
  selectStudentsTable.value = false;
  selectedClass.value = null;
  selectedClassData.value = null;
};

const startDate = ref();
const endDate = ref();

const fetchDailyTasksDataWithDateRange = async () => {
  if (!startDate.value || !endDate.value) {
    alert('Select a start and end date to filter by.')
    return false;
  }
  const formattedStartDate = moment(startDate.value).format('YYYY-MM-DD');
  const formattedEndDate = moment(endDate.value).format('YYYY-MM-DD');
  const payload = {
    school: filterStore.selectedFilters.school,
    grade: filterStore.selectedFilters.gradeLevel,
    startDate: formattedStartDate,
    endDate: formattedEndDate,
  }
  if (filterStore.selectedFilters.classGroup.length > 0) {
    payload.classGroup = filterStore.selectedFilters.classGroup;
  }
  payload.subject = filterStore.selectedFilters.subject;
  payload.timezone = moment.tz.guess();
  // Fetch the daily tasks data with the date filters
  await activityStore.fetchDailyTasksData(payload);

  // Generate the weeks between the start and end dates
  generateWeeksBetweenDates();

  // Update the bar graph data
  updateBarGraphData();
};

const generateWeeksBetweenDates = () => {
  // Clear any existing dates
  dates.value = [];
  // Calculate the number of weeks between the start and end dates
  const start = moment(startDate.value).startOf('week');
  const end = moment(endDate.value).startOf('week');
  const weeks = Math.ceil(moment.duration(end.diff(start)).asWeeks());
  // Generate the weeks between the start and end dates
  for (let week = 0; week <= weeks; week++) {
    const date = moment(start).add(week, "weeks");
    const formattedDate = date.format("YYYY-ww");
    dates.value.push(formattedDate);
  }
};

const updateBarGraphData = () => {
  barGraphData.value = null;
  barGraphData.value = dates.value?.map((date) => {
    // Find the task data for the corresponding date (full date comparison)
    const taskData =
      activityStore.getDailyTasksData?.tasksCompletionGraph?.find(
        (task: any) => task.week === date // Compare the full date string now
      );

    moment.updateLocale("en", {
      week: {
        dow: 1, // First day of week is Monday
        doy: 4  // First week of year must contain 4 January (7 + 1 - 4)
      }
    });

    const formattedDate = moment(date, "YYYY-ww").startOf("week").format("DD MMM");

    // Return the day and the number of students for the graph
    return {
      week: formattedDate,
      students: taskData?.count || 0,
      studentsWhoCompletedTasks: taskData?.usersWhoCompletedTasks || [],
      color: generateProgressBarBg(
        Math.min(
          Math.round(((taskData?.count || 0) / totalLearners.value) * 100),
          100
        )
      ),
      totalLearners: totalLearners.value,
    };
  });
};

const onStartDateChange = (newStartDate: Date) => {
  startDate.value = newStartDate;
};

const onEndDateChange = (newEndDate: Date) => {
  endDate.value = newEndDate;
};


return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_modal = _resolveComponent("modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageHeaderComponent, {
      pageHeading: _ctx.$t('overview_page.header'),
      filterVariant: "gradeSubject",
      includeAll: false
    }, null, 8, ["pageHeading"]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(LoadingSpinnerComponent),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_6, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-info-circle',
                    title: 'rl info circle',
                    "aria-hidden": "true"
                  })
                ])), [
                  [
                    _directive_tooltip,
                    _ctx.$t('overview_page.tooltips.active_last'),
                    "left",
                    { tooltip: true }
                  ]
                ])
              ]),
              _createElementVNode("h4", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("overview_page.active_last_7_days")), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h4", _hoisted_10, _toDisplayString(activeTime.value.percentageActiveInLast7Days), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _hoisted_13,
                _createElementVNode("h5", _hoisted_14, _toDisplayString(_ctx.$t("overview_page.student_active")), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", {
                  class: _normalizeClass('h-[8px] rounded-full ' +
                activeWithin7DaysColours(
                  activeTime.value.progressbar.percentageActiveInLast7Days
                )
                ),
                  style: _normalizeStyle('width:' +
                  Math.min(
                    activeTime.value.progressbar.percentageActiveInLast7Days,
                    100
                  ) +
                  '%'
                  )
                }, null, 6)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(LoadingSpinnerComponent),
              _createElementVNode("div", _hoisted_18, [
                _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_19, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-info-circle',
                    title: 'rl info circle',
                    "aria-hidden": "true"
                  })
                ])), [
                  [
                    _directive_tooltip,
                    _ctx.$t('overview_page.tooltips.active_time'),
                    "left",
                    { tooltip: true }
                  ]
                ])
              ]),
              _createElementVNode("h4", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("overview_page.active_time")), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("h4", _hoisted_23, _toDisplayString(activeTime.value.averageAppTimePerLearner) + " min ", 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("h4", _hoisted_26, " 35 " + _toDisplayString(_ctx.$t("overview_page.min")), 1),
                _createElementVNode("h5", _hoisted_27, _toDisplayString(_ctx.$t("overview_page.per_week")), 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", {
                  class: _normalizeClass('h-[8px] rounded-full ' +
                activeTimeColours(activeTime.value.averageAppTimePerLearner)
                ),
                  style: _normalizeStyle('width: ' +
                  Math.min(activeTime.value.progressbar.averageAppTimePerLearner, 100) +
                  '%'
                  )
                }, null, 6)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createVNode(LoadingSpinnerComponent),
              _createElementVNode("div", _hoisted_31, [
                _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_32, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-info-circle',
                    title: 'rl info circle',
                    "aria-hidden": "true"
                  })
                ])), [
                  [
                    _directive_tooltip,
                    _ctx.$t('overview_page.tooltips.time_learning'),
                    "left",
                    { tooltip: true }
                  ]
                ])
              ]),
              _createElementVNode("h4", _hoisted_33, [
                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("overview_page.time_spent_learning")), 1)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("h4", _hoisted_36, _toDisplayString(activeTime.value.percentageTimeSpentLearning), 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _hoisted_39,
                _createElementVNode("h5", _hoisted_40, _toDisplayString(_ctx.$t("overview_page.per_week")), 1)
              ]),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", {
                  class: _normalizeClass('h-[8px] rounded-full ' +
                averageTimeSpentLearningColours(
                  Math.min(
                    activeTime.value.progressbar.percentageTimeSpentLearning,
                    100
                  )
                )
                ),
                  style: _normalizeStyle('width: ' +
                  Math.min(
                    activeTime.value.progressbar.percentageTimeSpentLearning,
                    100
                  ) +
                  '%'
                  )
                }, null, 6)
              ])
            ])
          ])
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(LoadingSpinnerComponent),
                  _createElementVNode("div", _hoisted_46, [
                    _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_47, [
                      _createVNode(_component_rl_icon, {
                        icon: 'rl-info-circle',
                        title: 'rl info circle',
                        "aria-hidden": "true"
                      })
                    ])), [
                      [
                        _directive_tooltip,
                        _ctx.$t('overview_page.tooltips.daily_task'),
                        "left",
                        { tooltip: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("h2", _hoisted_49, _toDisplayString(_ctx.$t("overview_page.daily_tasks")), 1),
                    _createElementVNode("div", _hoisted_50, [
                      _createVNode(_unref(DatePicker), {
                        modelValue: startDate.value,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((startDate).value = $event)),
                          onStartDateChange
                        ]
                      }, {
                        default: _withCtx(({ inputValue, inputEvents }) => [
                          _createElementVNode("input", _mergeProps({
                            type: "text",
                            value: inputValue
                          }, _toHandlers(inputEvents, true), {
                            class: "border border-gray-300 rounded-lg shadow-box px-2 py-1 w-[40%] focus:outline-none focus:ring-2 focus:ring-blue-500 text-base font-normal text-gray-900",
                            placeholder: "Start Date"
                          }), null, 16, _hoisted_51)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("span", null, [
                        _createVNode(_component_rl_icon, {
                          icon: 'rl-right-arrow',
                          title: 'rl right arrow',
                          "aria-hidden": "true"
                        })
                      ]),
                      _createVNode(_unref(DatePicker), {
                        modelValue: endDate.value,
                        "onUpdate:modelValue": [
                          _cache[1] || (_cache[1] = ($event: any) => ((endDate).value = $event)),
                          onEndDateChange
                        ]
                      }, {
                        default: _withCtx(({ inputValue, inputEvents }) => [
                          _createElementVNode("input", _mergeProps({
                            type: "text",
                            value: inputValue
                          }, _toHandlers(inputEvents, true), {
                            class: "border border-gray-300 rounded-lg shadow-box px-2 py-1 w-[40%] focus:outline-none focus:ring-2 focus:ring-blue-500 text-base font-normal text-gray-900",
                            placeholder: "End Date"
                          }), null, 16, _hoisted_52)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "text-gray-700 border border-gray-300 text-sm font-semibold px-2 py-1.5 bg-white rounded-lg flex flex-row items-center gap-1.5",
                        onClick: fetchDailyTasksDataWithDateRange
                      }, [
                        _createElementVNode("span", null, [
                          _createVNode(_component_rl_icon, {
                            icon: 'rl-reload-icon',
                            title: 'rl reload icon',
                            "aria-hidden": "true"
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createVNode(BarGraphComponent, {
                    data: barGraphData.value,
                    months: x_axis_months.value,
                    onTaskCompletionLearners: taskCompletionLearners
                  }, null, 8, ["data", "months"])
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createVNode(LoadingSpinnerComponent),
                      _createElementVNode("div", _hoisted_57, [
                        _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_58, [
                          _createVNode(_component_rl_icon, {
                            icon: 'rl-info-circle',
                            title: 'rl info circle',
                            "aria-hidden": "true"
                          })
                        ])), [
                          [
                            _directive_tooltip,
                            _ctx.$t('overview_page.tooltips.at_a_glance'),
                            "left",
                            { tooltip: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("h2", _hoisted_59, _toDisplayString(_ctx.$t("overview_page.at_glence")), 1),
                      (pieChartData.value)
                        ? (_openBlock(), _createBlock(PieChartComponent, {
                            key: 0,
                            data: pieChartData.value,
                            onLearnerTaskCompletionStatus: learnerTaskCompletionStatus
                          }, null, 8, ["data"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-xl',
      open: showLearnersBulkUploadProgressModal.value,
      onLocalModalOpen: _cache[2] || (_cache[2] = ($event: any) => (showLearnersBulkUploadProgressModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", {
                class: "absolute top-6 right-4 cursor-pointer",
                onClick: uploadInProgress
              }, [
                _createVNode(_component_rl_icon, {
                  icon: 'rl-large-close',
                  title: 'rl large close',
                  "aria-hidden": "true"
                })
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_rl_icon, {
                  icon: 'rl-green-tick',
                  title: 'rl green tick',
                  "aria-hidden": "true"
                })
              ]),
              _createElementVNode("h1", _hoisted_63, _toDisplayString(_ctx.$t("bulk_learner_upload_component.modal.header")), 1),
              _createElementVNode("p", {
                class: "font-normal text-sm text-gray-600 text-center mt-2",
                innerHTML: _ctx.$t('bulk_learner_upload_component.modal.sub_header')
            
              }, null, 8, _hoisted_64),
              _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.$t("bulk_learner_upload_component.modal.important_info")), 1),
              _createElementVNode("button", {
                onClick: uploadInProgress,
                class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8 mt-8 w-full"
              }, _toDisplayString(_ctx.$t("students_view.done")), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(LearnerListModalComponent, {
      show: showLearnersListModal.value,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((showLearnersListModal).value = $event))
    }, {
      headerSlot: _withCtx(() => [
        _createTextVNode(_toDisplayString(learnerListModalTitle.value), 1)
      ]),
      descriptionSlot: _withCtx(() => [
        _createElementVNode("table", _hoisted_66, [
          _hoisted_67,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(learnersList.value, (learner) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: learner._id,
                onClick: ($event: any) => (showStudentModal(learner._id)),
                class: "cursor-pointer"
              }, [
                _createElementVNode("td", null, _toDisplayString(learner.firstName), 1),
                _createElementVNode("td", null, _toDisplayString(learner.lastName), 1),
                _createElementVNode("td", null, _toDisplayString(learner.grade), 1),
                _createElementVNode("td", null, _toDisplayString(learner.classes[0].name), 1)
              ], 8, _hoisted_68))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})